import React, {useEffect, useState} from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import {TreeItem} from "@mui/x-tree-view/TreeItem";
import {TreeView} from "@mui/x-tree-view/TreeView";
import {withTranslation} from "react-i18next";
import {goToDatasetsSearch} from "../../links";

const treeItemStyle = {
  backgroundColor: "none !important",
  "&:hover": {
    backgroundColor: "none !important"
  },
  "& .MuiTreeItem-content": {
    background: "none !important",
    padding: "4px 8px"
  },
  "& .MuiTreeItem-label": {
    background: "none !important"
  }
};

function ResultTree(props) {
  const {catalog, query, node, filters = [], categoryGroupsWithCount, uncategorizedDatasetsCount, t} = props;

  const [expanded, setExpanded] = useState([]);

  useEffect(() => {
    setExpanded(
      ((catalog.hasCategorySchemes ? categoryGroupsWithCount : categoryGroupsWithCount?.[0]?.categories) || []).map(
        ({id}) => id
      )
    );
  }, [catalog, categoryGroupsWithCount]);

  const getTreeItems = (tree, prevPath, noCheckbox = false) =>
    tree.map((cat, i) => {
      const selected = !!filters.find(filter => filter.includes(cat.id));

      return (
        <TreeItem
          key={i}
          nodeId={cat.id}
          label={
            <Grid spacing={1} container alignItems="flex-start" wrap="nowrap">
              {!noCheckbox && (
                <Grid item>
                  <label htmlFor={`result-tree__checkbox__${cat.id}`} style={{display: "none"}}>
                    {cat.label}
                  </label>
                  <Checkbox
                    id={`result-tree__checkbox__${cat.id}`}
                    checked={selected}
                    sx={{
                      padding: "0px",
                      transform: "translateY(-2px)"
                    }}
                    onClick={e => {
                      goToDatasetsSearch(
                        node.code,
                        query,
                        selected ? filters.filter(path => !path.includes(cat.id)) : [...filters, [...prevPath, cat.id]]
                      );
                      e.stopPropagation();
                    }}
                  />
                </Grid>
              )}
              <Grid item style={{width: "100%"}}>
                {cat.label}
                {!noCheckbox && (
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "bold",
                      marginLeft: "4px"
                    }}
                  >
                    {" "}
                    ({cat.count})
                  </Box>
                )}
              </Grid>
            </Grid>
          }
          sx={treeItemStyle}
        >
          {cat.categories && cat.categories.length > 0 && getTreeItems(cat.categories, [...prevPath, cat.id])}
        </TreeItem>
      );
    });

  const uncategorizedSelected = !!filters.find(filter => filter.includes("uncategorized"));

  return (
    <Box
      sx={{
        background: "#F5F5F5",
        paddingTop: "8px",
        paddingBottom: "8px"
      }}
    >
      {categoryGroupsWithCount.length > 0 && (
        <TreeView
          key={query ? `result-tree-categories-${query}` : "result-tree-categories"}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          expanded={expanded}
          onNodeToggle={(_, nodeIds) => setExpanded(nodeIds)}
          sx={{
            color: theme => theme.palette.text.primary
          }}
        >
          {getTreeItems(
            catalog.hasCategorySchemes ? categoryGroupsWithCount : categoryGroupsWithCount[0].categories,
            [],
            catalog.hasCategorySchemes
          )}
        </TreeView>
      )}
      {uncategorizedDatasetsCount > 0 && (
        <TreeView
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          key={query ? `result-tree-uncategorized-${query}` : "result-tree-uncategorized"}
          sx={{
            color: theme => theme.palette.text.primary
          }}
        >
          <TreeItem
            key={"uncategorized"}
            nodeId={"uncategorized"}
            sx={treeItemStyle}
            label={
              <Grid
                spacing={1}
                container
                alignItems="flex-start"
                style={{flexWrap: "nowrap", marginTop: 4, alignItems: "baseline"}}
              >
                <Grid item>
                  <label htmlFor="result-tree__checkbox__uncategorized" style={{display: "none"}}>
                    {t("commons.catalog.uncategorized")}
                  </label>
                  <Checkbox
                    id="result-tree__checkbox__uncategorized"
                    checked={uncategorizedSelected}
                    sx={{
                      padding: "0px",
                      transform: "translateY(-2px)"
                    }}
                    onClick={e => {
                      goToDatasetsSearch(
                        node.code,
                        query,
                        uncategorizedSelected
                          ? filters.filter(path => JSON.stringify(path) !== JSON.stringify(["uncategorized"]))
                          : [...filters, ["uncategorized"]]
                      );
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid style={{width: "100%"}} item>
                  {t("commons.catalog.uncategorized")}{" "}
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "bold",
                      marginLeft: "4px"
                    }}
                  >
                    ({uncategorizedDatasetsCount})
                  </Box>
                </Grid>
              </Grid>
            }
          />
        </TreeView>
      )}
    </Box>
  );
}

export default withTranslation()(ResultTree);
